
if (window.location.href.includes('/fr')) {
    $("body").addClass("language_convert");
}


$(document).ready(function() {

    $(".custom-banner-slider").slick({
        dots: !0,
        infinite: !0,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    }), $(".department-wrap").slick({
        dots: !1,
        arrows: !0,
        prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button aria-label="Right Arrow"  class="slide-arrow next-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
        infinite: !0,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 481,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, ]
    }), $(".slider-wrap").slick({
        dots: !1,
        arrows: !0,
        prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button aria-label="Left Arrow" class="slide-arrow next-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
        infinite: !0,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    }), $(".testimonial-text-slider").slick({
        slidesToShow: 1,
        arrows: !0,
        prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button aria-label="Right Arrow" class="slide-arrow next-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
        asNavFor: ".testimonial-reviewer-slider-wrap"
    }), $(".testimonial-reviewer-slider-wrap").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: ".testimonial-text-slider",
        vertical: !0,
        focusOnSelect: !0,
        autoplay: !1,
        centerMode: !0,
        infinite: !0,
        centerPadding: "0px"
    }), $(".slider-our-prod").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: !1,
        prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button aria-label="Right Arrow" class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
        arrows: !0,
        infinite: !0,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: !0,
                dots: !1
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, ]
    }), $(".collection-image-wrap").slick({
        dots: !0,
        arrows: !0,
        prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button aria-label="Right Arrow" class="slide-arrow next-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
        infinite: !0,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [{
            breakpoint: 568,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    })
}), $(".slider-our-prod").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    dots: !1,
    prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow: '<button aria-label="Right Arrow" class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
    arrows: !0,
    infinite: !0,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: !0,
            dots: !1
        }
    }, {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
    }, {
        breakpoint: 480,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
    }, ]
}),
  
//   $(document).ready(function() {
//     setTimeout(function() {
//         $("#recently-viewed-products").slick({
//             slidesToShow: 4,
//             slidesToScroll: 1,
//             adaptiveHeight: !0,
//             dots: !1,
//             prevArrow: '<button aria-label="Left Arrow" class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
//             nextArrow: '<button aria-label="Right Arrow" class="slide-arrow next-arrow"><i class="fa-solid fa-chevron-right"></i></button>',
//             arrows: !0,
//             infinite: !0,
//             responsive: [{
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 1,
//                     infinite: !0,
//                     dots: !1
//                 }
//             }, {
//                 breakpoint: 600,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1
//                 }
//             }, {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1
//                 }
//             }, ]
//         }), $("body").addClass("active-history")
//     }, 5e3)
// }),
 $(document).ready(function() {
    setTimeout(function() {
        $(".price_custom").each(function() {
            var s = $(this).text(),
                e = parseFloat(s = $.trim(s)) / 100;
            e = e.toFixed(2), $(this).text(e)
        })
    }, 7e3)
}), jQuery(document).ready(function(s) {
    s(document).click(function(e) {
        var o = s(e.target);
        o.closest(".menu-drawer-container").length || o.closest(".header__icon--menu").length || s(".menu-drawer-container").removeClass("menu-opening").removeAttr("open")
    }), s(".header__icon--menu").click(function() {
        s(".menu-drawer-container").toggleClass("menu-opening")
    })
}), $(".tab").on("click", function(s) {
    s.preventDefault();
    var e = this.getAttribute("data-toggle-target");
    $(".tab, .tab-content").removeClass("active"), $(this).addClass("active"), $(e).addClass("active")
}), $(".crowsel_sec_cst").slick({
    arrow: !0,
    dots: !1,
    infinite: !1,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: !0,
            dots: !1
        }
    }, {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }, ]
}), $(document).ready(function() {
    $(".tab1").addClass("active"), $("#tabs_cst div").on("click", function() {
        $("#tabs_cst div").removeClass("active"), $(this).addClass("active"), $(this).data("tab")
    }), $(".header-wrapper>header.header>nav.header__inline-menu>ul.list-menu.list-menu--inline>li").hover(function() {
        $("body").toggleClass("result_hover")
    })
}), $(function() {
    var s = $(".js-dropdown-list"),
        e = $(".js-link");
    e.click(function(e) {
        e.preventDefault(), s.slideToggle(200)
    }), s.find("li").click(function() {
        var o = $(this).html(),
            i = '<i class="fa fa-chevron-down"></i>';
        e.html(o + i), s.slideToggle(200), "* Reset" === o && e.html("Select one option" + i)
    })
});
var web_url = window.location.href;

function show() {
    var s = document.getElementById("CustomerPassword"),
        e = document.getElementById("EYE");
    "password" === s.type ? (s.type = "text", e.src = "https://i.stack.imgur.com/waw4z.png") : (s.type = "password", e.src = "https://i.stack.imgur.com/Oyk1g.png")
}
$(".header__inline-menu .list-menu.list-menu--inline li a").each(function() {
    var s = $(this).attr("href");
    if (-1 !== web_url.indexOf(s)) return $(this).addClass("active"), !1
}), $(document).ready(function() {
    $(".refresh-link").on("click", function(s) {
        setTimeout(function() {
            $(".icon-close").click(), $("body").removeClass("overflow-hidden-tablet")
        }, 500)
    })
}), jQuery(".product__info-wrapper").each(function() {
    jQuery(this).find("div.product__accordion:first").find("details").attr("open", "")
}), jQuery(".toggle-hide-show").click(function() {
    jQuery(this).toggleClass("fa-eye fa-eye-slash"), "password" == (input = jQuery(this).parent().find("input")).attr("type") ? input.attr("type", "text") : input.attr("type", "password")
});
// $(document).ready(function(){
//         // Check if the success popup is present
//         {%- if form.posted_successfully? -%}
//             // Auto-hide after 5 seconds
//             setTimeout(function() {
//                 $('#successPopup').hide();
//             }, 5000); // 5000 milliseconds = 5 seconds
//         {%- endif -%}
//     });
setTimeout(function() {
    $('.newsletter.center div#successPopup').hide();
}, 3000);

